import React from 'react';
import { ExpandedParamsCardProvider } from './ExpandedParamsCardContext';
import { ExpandedParamsCardContainer } from './ExpandedParamsCardContainer';

interface ExpandedParamsCardProviderWrapperProps {
  readingsList: any[];
  resumeList: any[];
}

/**
 * Componente wrapper que proporciona el contexto ExpandedParamsCard al componente ExpandedParamsCardContainer
 * Utiliza el ExpandedParamsCardProvider para compartir el estado entre componentes
 */
export const ExpandedParamsCardProviderWrapper: React.FC<ExpandedParamsCardProviderWrapperProps> = ({ 
  readingsList, 
  resumeList 
}) => {
  // Valores iniciales que se pueden pasar al contexto si es necesario
  const initialValue = {};
  
  return (
    <ExpandedParamsCardProvider initialValue={initialValue}>
      <ExpandedParamsCardContainer/>
    </ExpandedParamsCardProvider>
  );
};

export default ExpandedParamsCardProviderWrapper;
